/** Copy shown while `ZoomClientProvider` is still resolving its async
 *  `client.init()` — the room cannot be joined until it hydrates. */
export const ZOOM_CLIENT_INIT_MESSAGE = "Setting up your video connection…";

export const TELEHEALTH_CANCEL_LABEL = "Cancel";

export const TELEHEALTH_LEAVE_LABEL = "Leave";
export const TELEHEALTH_REJOIN_LABEL = "Ask to join again";

/** Grace period after a deny during which re-knocks from the same userId are
 *  dropped. Covers knocks already in flight when the host decided, without
 *  permanently blocking a guest whose userId is reused on rejoin. */
export const DENY_REKNOCK_SUPPRESS_MS = 5000;

/** Gap between broadcasting a deny and removing the guest, so the decision
 *  reaches them before the SDK tears their connection down. */
export const DENY_REMOVE_DELAY_MS = 400;

/** How long a user keeps the speaking indicator after the SDK last reported
 *  them active. Bridges the gaps between `active-speaker` events so the bars
 *  don't strobe on natural pauses between words. */
export const SPEAKING_DECAY_MS = 1200;
/** How often the decay sweep re-evaluates who is still speaking. */
export const SPEAKING_SWEEP_MS = 250;
/** Bars drawn in the speaking indicator, with their animation offsets. */
export const SPEAKING_BARS = [
  { id: "outer-left", delayMs: 0 },
  { id: "inner-left", delayMs: 150 },
  { id: "inner-right", delayMs: 300 },
  { id: "outer-right", delayMs: 150 },
] as const;

export const PARTICIPANT_AUDIO_LABEL = {
  SPEAKING: "Speaking",
  MUTED: "Muted",
  UNMUTED: "Unmuted",
} as const;

export const HOST_MUTE_LABEL = "Mute participant";
export const HOST_ASK_UNMUTE_LABEL = "Ask to unmute";
/** Zoom forbids the host unmuting someone directly — the participant gets a
 *  consent prompt instead, delivered as `host-ask-unmute-audio`. */
export const HOST_ASK_UNMUTE_MESSAGE = "The host has asked you to unmute.";
